<template>
    <header class="container-fluid">
        <nav class="row">
            <ul class="col-12 content-center-aligned">
                <li>
                    <a href v-scroll-to="'#about'">About</a>
                </li>
                <li class="divider">•</li>
                <li>
                    <a href v-scroll-to="'#news'">News</a>
                </li>
                <li class="divider">•</li>
                <li>
                    <a href v-scroll-to="'#team'">Team</a>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
export default {
    name: "Header",
    props: {
        msg: String
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";

header,
nav {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    margin: 0;
}
.divider {
    color: $white;
    font-size: 36px;
    vertical-align: text-bottom;
    padding-top: 10px;
    line-height: 14px;
}

nav {
    padding: 20px 0;
    background: #333;

    ul {
        margin: 0 !important;
        padding: 0 !important;

        li {
            list-style: none;
            display: inline-block;
            @include font-size(1.8);
            margin: 0 5px;

            a {
                color: $white;
                text-decoration: none;

                &:hover {
                    border-bottom: 1px solid $white;
                }
            }
        }
    }
}
</style>
